import React from 'react';
import { PeriodSwitcher, type LstPeriodView } from './PeriodSwitcher';

interface LstRibbonPeriodSlotProps {
  showPeriod?: boolean;
  periodView?: LstPeriodView;
  onPeriodChange?: (v: LstPeriodView) => void;
}

/** Seletor de período alinhado à direita do ribbon — sem títulos duplicados. */
export const LstRibbonPeriodSlot: React.FC<LstRibbonPeriodSlotProps> = ({
  showPeriod = false,
  periodView = 'dia',
  onPeriodChange,
}) => {
  if (!showPeriod || !onPeriodChange) return null;
  return (
    <div className="ml-auto flex shrink-0 items-center">
      <PeriodSwitcher value={periodView} onChange={onPeriodChange} />
    </div>
  );
};

/** @deprecated Use LstRibbonPeriodSlot — mantido para imports legados. */
export const LstRibbonContextBar = LstRibbonPeriodSlot;

export const LST_SCREEN_TITLES = {
  'central-gestao': 'Central de Gestão',
  'meu-padrao': 'Meu Padrão de Trabalho',
  construtor: 'Planner TPL',
  auditoria: 'Auditoria de Camada',
  'cadeia-ajuda': 'Cadeia de Ajuda',
  diagnostico: 'Diagnóstico',
  configuracao: 'Engenharia do Padrão',
} as const;
